import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ page, pages, total, limit, onPageChange }) => {
  if (total === 0) return null;

  const startRange = (page - 1) * limit + 1;
  const endRange = Math.min(page * limit, total);

  // Generate page numbers
  const pageNumbers = [];
  const maxButtons = 5;
  let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
  let endPage = Math.min(pages, startPage + maxButtons - 1);

  if (endPage - startPage + 1 < maxButtons) {
    startPage = Math.max(1, endPage - maxButtons + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-4 px-2 text-sm text-slate-500 border-t border-slate-100/80 mt-4">
      <div>
        Showing <span className="font-medium text-slate-700">{startRange}</span> to{' '}
        <span className="font-medium text-slate-700">{endRange}</span> of{' '}
        <span className="font-medium text-emerald-700">{total}</span> results
      </div>

      <div className="flex items-center space-x-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="inline-flex items-center justify-center p-2 rounded-lg bg-white border border-slate-100 text-slate-600 hover:bg-slate-50 hover:text-slate-900 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>

        {startPage > 1 && (
          <>
            <button
              onClick={() => onPageChange(1)}
              className="px-3 py-1.5 rounded-lg bg-white border border-slate-100 text-slate-600 hover:bg-slate-50 transition"
            >
              1
            </button>
            {startPage > 2 && <span className="px-1 text-slate-600">...</span>}
          </>
        )}

        {pageNumbers.map((num) => (
          <button
            key={num}
            onClick={() => onPageChange(num)}
            className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold transition ${
              page === num
                ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg shadow-emerald-600/30'
                : 'bg-white border border-slate-100 text-slate-600 hover:bg-slate-50'
            }`}
          >
            {num}
          </button>
        ))}

        {endPage < pages && (
          <>
            {endPage < pages - 1 && <span className="px-1 text-slate-600">...</span>}
            <button
              onClick={() => onPageChange(pages)}
              className="px-3 py-1.5 rounded-lg bg-white border border-slate-100 text-slate-600 hover:bg-slate-50 transition"
            >
              {pages}
            </button>
          </>
        )}

        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= pages}
          className="inline-flex items-center justify-center p-2 rounded-lg bg-white border border-slate-100 text-slate-600 hover:bg-slate-50 hover:text-slate-900 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
